function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 150,
  y: 15,
  width: 60,
  height: 100
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M150.665 15.6118H209.295V114.814H150.665V15.6118Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.875 17.026L208.905 110.394C210.025 112.367 208.601 114.814 206.332 114.814H153.624C151.99 114.814 150.665 113.49 150.665 111.855V18.403C150.665 15.542 154.462 14.539 155.875 17.026Z",
  fill: "#E1EAFF"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M174.944 115.365H136.54C136.54 115.365 158.035 33.838 172.937 47.661C172.937 47.661 181.708 50.099 178.47 88.141",
  fill: "#3370FF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M174.944 115.365H136.54C136.54 115.365 158.035 33.838 172.937 47.661C172.937 47.661 181.708 50.099 178.47 88.141",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M146.807 61.9137C146.807 61.9137 143.394 29.5907 141.842 27.0927C138.15 21.1467 138.569 35.7727 140.121 35.6897C142.477 35.5627 138.413 23.1917 136.207 23.1917C134.268 23.1917 134.573 35.4117 136.54 35.2607C138.408 35.1167 134.496 23.7407 132.292 23.8587C129.469 24.0117 132.713 43.5497 132.713 43.5497C132.713 43.5497 129.59 78.7197 132.384 84.0737C135.179 89.4277 148.566 87.9566 146.807 61.9137Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M146.807 61.9137C146.807 61.9137 143.394 29.5907 141.842 27.0927C138.15 21.1467 138.569 35.7727 140.121 35.6897C142.477 35.5627 138.413 23.1917 136.207 23.1917C134.268 23.1917 134.573 35.4117 136.54 35.2607C138.408 35.1167 134.496 23.7407 132.292 23.8587C129.469 24.0117 132.713 43.5497 132.713 43.5497C132.713 43.5497 129.59 78.7197 132.384 84.0737C135.179 89.4277 148.566 87.9566 146.807 61.9137Z",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.991 21.7186C143.991 21.7186 144.064 30.8536 145.282 35.1266C145.435 35.6646 147.712 35.5046 148.863 36.4416C150.014 37.3776 150.041 39.4106 151.974 40.1746C153.945 40.9536 156.265 41.4936 158.823 41.4936C168.926 41.4936 159.468 22.3636 158.823 21.7186C158.178 21.0736 143.991 21.7186 143.991 21.7186Z",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.991 21.7186C143.991 21.7186 144.064 30.8536 145.282 35.1266C145.435 35.6646 147.712 35.5046 148.863 36.4416C150.014 37.3776 150.041 39.4106 151.974 40.1746C153.945 40.9536 156.265 41.4936 158.823 41.4936C168.926 41.4936 159.468 22.3636 158.823 21.7186C158.178 21.0736 143.991 21.7186 143.991 21.7186Z",
  stroke: "#126DFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.863 70.0095C148.863 70.0095 162.62 38.0535 173.51 44.8605C184.402 51.6665 165.023 82.5314 165.023 82.5314L148.863 70.0095Z",
  fill: "#3370FF"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.863 70.0095C148.863 70.0095 162.62 38.0534 173.51 44.8605C184.402 51.6665 165.023 82.5314 165.023 82.5314L148.863 70.0095Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.917 25.5876C145.517 28.6186 156.602 27.6656 156.602 27.6656C156.602 27.6656 160.564 24.9236 161.295 29.6716C161.603 31.6746 158.607 34.9386 158.607 34.9386C158.607 34.9386 160.614 43.5716 169.355 43.4286C174.678 43.3416 177.738 48.0146 177.309 53.3876C178.011 56.4776 178.913 60.1466 179.188 62.3446C180.175 70.2256 179.188 82.0476 179.188 82.0476C179.188 82.0476 199.021 71.8926 196.285 54.5996C194.18 41.2936 172.589 38.7656 169.41 28.7856C164.324 12.8156 154.159 3.29856 145.567 12.7626C141.306 17.4576 141.132 23.5056 142.917 25.5876Z",
  fill: "#FFC60A"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.705 82.3709C149.705 82.3709 163.892 36.2759 161.312 35.3839C158.732 34.4899 158.616 34.5799 155.665 34.1049C152.714 33.6309 152.529 34.9689 150.809 34.0799C149.09 33.1899 120.615 90.6639 135.088 96.8229C150.151 103.233 163.783 82.0659 163.783 82.0659L152.441 73.2769L149.705 82.3709Z",
  fill: "white"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.58 81.8513C149.58 81.8513 163.767 35.7563 161.187 34.8643C158.607 33.9703 148.72 47.1643 151.729 47.6613C154.739 48.1573 158.491 34.0603 155.54 33.5853C152.589 33.1113 145.668 44.8353 147.431 45.6433C151.748 47.6213 152.404 34.4493 150.684 33.5603C148.965 32.6703 120.49 90.1443 134.963 96.3033C150.026 102.713 163.658 81.5463 163.658 81.5463L152.316 72.7573L149.58 81.8513Z",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M158.922 49.0701C158.922 49.0701 169.434 45.1061 166.188 49.0701C163.961 51.7891 156.863 56.7681 156.863 56.7681L158.922 49.0701Z",
  fill: "white"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M158.922 49.0701C158.922 49.0701 169.434 45.1061 166.188 49.0701C163.961 51.7891 156.863 56.7681 156.863 56.7681L158.922 49.0701Z",
  stroke: "#126DFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.328 29.7379C147.328 30.3559 147.829 30.8569 148.447 30.8569C149.064 30.8569 149.565 30.3559 149.565 29.7379C149.565 29.1199 149.064 28.6189 148.447 28.6189C147.829 28.6189 147.328 29.1199 147.328 29.7379Z",
  fill: "#3370FF"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3492 58.1374L53.3652 50.8904",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M54.6379 64.5466L46.1279 62.8596",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3376 61.3123L52.8926 57.8923",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M222.5 114.5H34.4999",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.9145 58.5545C68.2355 59.1455 68.7335 59.6465 69.3805 59.9695C71.0615 60.8105 73.1035 60.1295 73.9445 58.4495L79.3805 47.5815C80.9145 44.5145 83.5665 42.2215 86.8515 41.1275C90.1345 40.0335 93.6325 40.2755 96.6995 41.8105C99.7685 43.3435 102.062 45.9955 103.154 49.2815C104.248 52.5645 104.006 56.0615 102.472 59.1295L97.0365 69.9965C96.1945 71.6785 96.8785 73.7225 98.5585 74.5615C100.239 75.4025 102.283 74.7205 103.123 73.0405L108.558 62.1735C110.905 57.4795 111.278 52.1375 109.61 47.1295C107.94 42.1215 104.437 38.0715 99.7425 35.7245C95.0505 33.3765 89.7075 33.0035 84.6995 34.6715C79.6915 36.3405 75.6425 39.8445 73.2945 44.5375L67.8595 55.4055C67.3435 56.4395 67.4015 57.6115 67.9145 58.5545Z",
  fill: "#E1EAFF"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M106.795 65.1618C109.143 60.4678 109.516 55.1258 107.848 50.1178C106.178 45.1098 102.675 41.0588 97.9809 38.7128C93.2879 36.3648 87.9439 35.9918 82.9379 37.6608C77.9299 39.3288 73.8799 42.8328 71.5319 47.5258L66.0969 58.3928C65.5799 59.4278 65.6399 60.5998 66.1519 61.5428C66.4739 62.1338 66.9719 62.6348 67.6179 62.9578C69.2989 63.7988 71.3419 63.1178 72.1829 61.4368L77.6169 50.5698C79.1519 47.5028 81.8049 45.2098 85.0889 44.1158C88.3719 43.0218 91.8699 43.2648 94.9369 44.7988C98.0059 46.3318 100.3 48.9838 101.392 52.2688C102.485 55.5528 102.243 59.0508 100.709 62.1178L95.2739 72.9848C94.4319 74.6668 95.1159 76.7108 96.7959 77.5498C98.4769 78.3908 100.521 77.7088 101.36 76.0288",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.9771 74.8328L48.1361 84.1148C42.3461 90.9678 43.2171 101.312 50.0701 107.102C56.9231 112.891 67.2671 112.021 73.0561 105.167L80.8971 95.8858",
  fill: "white"
});
var _ref25 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 41,
  y: 71,
  width: 44,
  height: 44
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41 71.53H84.2V114.237H41V71.53Z",
  fill: "white"
}));
var _ref26 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.5501 114.237C55.9211 114.237 51.4971 112.63 47.9401 109.625C43.9501 106.255 41.5121 101.516 41.0711 96.284C40.6311 91.05 42.2441 85.971 45.6141 81.983L53.4541 72.702C54.6311 71.308 56.7141 71.133 58.1091 72.309C59.5021 73.487 59.6781 75.571 58.5011 76.964L50.6601 86.246C48.4291 88.886 47.3621 92.255 47.6541 95.729C47.9461 99.205 49.5621 102.347 52.2021 104.579C54.8421 106.808 58.2051 107.883 61.6861 107.584C65.1611 107.292 68.3031 105.676 70.5331 103.036L78.3751 93.754C79.5491 92.362 81.6331 92.184 83.0291 93.363C84.4221 94.54 84.5981 96.624 83.4201 98.017L75.5791 107.299C72.2111 111.287 67.4731 113.725 62.2391 114.166C61.6741 114.214 61.1111 114.237 60.5501 114.237Z",
  fill: "#3370FF"
}));
var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.9392 65.825L64.7842 89.684L84.9392 65.825Z",
  fill: "#FFC102"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.4969 90.5623C61.6699 91.2123 62.0359 91.8163 62.5879 92.2833C64.0239 93.4963 66.1699 93.3153 67.3829 91.8793L87.5379 68.0203C88.7519 66.5833 88.5669 64.4353 87.1359 63.2263C85.6989 62.0133 83.5539 62.1933 82.3409 63.6283L62.1839 87.4883C61.4379 88.3723 61.2209 89.5243 61.4969 90.5623Z",
  fill: "#FFC60A"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M86.8584 83.8123C86.8584 83.8123 97.7254 94.6263 100.538 113.529C100.538 113.529 102.209 106.308 105.738 105.317",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.653 83.8327C107.691 83.4847 102.577 88.0357 102.228 93.9967C101.881 99.9587 106.43 105.073 112.392 105.422C118.353 105.77 123.468 101.219 123.816 95.2577C124.165 89.2957 119.614 84.1817 113.653 83.8327Z",
  fill: "#F54A45"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M117.765 99.9597L108.277 89.2947",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M118.354 89.8826L107.689 99.3706",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgPcQuestionnaireExpired = function SvgPcQuestionnaireExpired(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 125,
    viewBox: "0 0 250 125",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPcQuestionnaireExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pc_questionnaire_expired.d937fdfb.svg";
export { ForwardRef as ReactComponent };